import {
  CustomFormattedDate,
  CustomFormattedMessage,
} from '../../../../i18n/i18n';
import { SidebarRow } from '../../../../components/sidebar/SidebarRow';
import { MaskedCardNumber } from '../../../../components/MaskedCardNumber';
import { PaymentPartnerRepresentation } from '../../../../components/dataRepresentation/PaymentPartnerRepresentation';
import { Transaction } from '../../../../models';

type BillingDetailsTableProps = {
  transaction: Transaction;
};

export const BillingDetailsTable = ({
  transaction,
}: BillingDetailsTableProps) => {
  return (
    <>
      <h6 className="padding-left-10 margin-top-20">
        <CustomFormattedMessage id="transactions.transactionsTable.header.billing" />
      </h6>
      <table
        className="table table-condensed"
        data-testid={'transactions-sidebar-billing-details'}
      >
        <colgroup>
          <col className="width-150" />
          <col />
        </colgroup>
        <tbody>
          <SidebarRow label="common.transaction.paymentPartner">
            <PaymentPartnerRepresentation
              paymentPartner={transaction.paymentDetails.paymentPartner}
            />
          </SidebarRow>
          <SidebarRow label="common.transaction.transactionDate">
            <CustomFormattedDate value={transaction.displayDate} />
          </SidebarRow>
          <SidebarRow
            label="common.transaction.completedAt"
            show={!!transaction.completedAt}
          >
            <CustomFormattedDate value={transaction.completedAt} />
          </SidebarRow>
          <SidebarRow label="common.card.type">
            <MaskedCardNumber
              lastFourDigits={transaction.paymentDetails.lastFourDigits}
            />
          </SidebarRow>
        </tbody>
      </table>
    </>
  );
};
